import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiSwitch, { SwitchProps } from '@mui/material/Switch';
import { Box } from '@mui/material';

interface IProps {
  label?: string | React.ReactNode;
}

export const Switch: React.FC<IProps & SwitchProps> = ({ label, ...props }) => {
  const switchComponent = label ? (
    <FormControlLabel control={<MuiSwitch color='primary' {...props} />} label={label} />
  ) : (
    <MuiSwitch color='primary' {...props} />
  );

  return <Box>{switchComponent}</Box>;
};
